<template>
  <div>
    <DynamicScroller
      v-if="list != undefined && list.length > 2"
      :items="list"
      :min-item-size="54"
      key-field="id"
      class="virtual-scroller"
    >
      <template v-slot="{ item, index, active }">
        <DynamicScrollerItem
          :item="item"
          :data-index="index"
          :active="active"
          :size-dependencies="[item.question.question]"
        >
          <QnAItem v-bind:item="item" :canVote="canVote" class="ma-1" />
        </DynamicScrollerItem>
      </template>
    </DynamicScroller>
    <v-item-group v-else>
      <transition-group name="flip-list" tag="div">
        <v-item v-for="item in list" v-bind:key="item.question.id">
          <QnAItem v-bind:item="item" :canVote="canVote" class="ma-1" />
        </v-item>
      </transition-group>
    </v-item-group>
    <div
      class="div-100 my-n3 d-flex align-center justify-center"
      v-if="loading"
    >
      <v-progress-circular
        indeterminate
        size="24"
        width="3"
        color="primary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import QnAItem from "./QnAItem";
import { mapState } from "vuex";
export default {
  components: {
    QnAItem,
  },
  props: {
    list: { Type: Array, required: true },
    canVote: { type: Boolean, default: true },
  },
  computed: {
    ...mapState({
      loading(state, getters) {
        return getters[`qna-${this.EventId}-${this.roomName}/GET_loading`];
      },
    }),
  },
};
</script>

<style>
</style>